<template>
  <div class="wrap personal-wrap flex-column">
    <div class="flex-this.currentAddress">
      <ul class="edit editaddress">
        <!-- <li>
          <mu-text-field type='number' errorText="这是必填项" :fullWidth='true' max='6' />
        </li> -->
        <li class="user-order-title">
          <p>
            <label>收货人</label>
            <input class="right ellipsis" type="text" v-model="currentAddress.consignee" placeholder="姓名" maxlength="32" />
            <!-- <mu-text-field type='number' hintText="提示文字" errorText="这是必填项" :fullWidth='true' /> -->
          </p>
        </li>
        <li class="user-order-title">
          <p>
            <label>联系电话</label>
            <input class="right ellipsis" v-model="currentAddress.mobile" placeholder="手机号码" type="number" minlength="11" maxlength="11" />
          </p>
        </li>
        <li class="user-order-title" @click="bottomPopup=true">
          <p>
            <label>所在地区</label>
            <input class="right ellipsis" placeholder="请选择省市区县" readonly :value="addressMsgShow" type="text" readonly="readonly">
          </p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </li>
        <li class="user-order-title">
          <p>
            <label>详细地址</label>
            <input class="right ellipsis" v-model="currentAddress.address" placeholder="详细地址需填写楼栋楼层或房间号信息" />
          </p>
        </li>
        <li class="user-order-title">
          <p>
            <label>邮政编码</label>
            <input class="right ellipsis" v-model="currentAddress.postCode" placeholder="选填，若您不清楚邮递区号，请填000000" type="text" maxlength="6" />
          </p>
        </li>
      </ul>
      <!-- 新的地址选择 position="bottom" popupClass="popup-bottom physical-popup"-->
      <div>
        <mu-popup position="bottom" popupClass="demo-popup-bottom popup-bottom physical-popup" :open="bottomPopup" @close="bottomPopup=false">
          <!-- <mu-appbar title="所在地区">
            <mu-flat-button slot="right" label="   " color="white" @click="bottomPopup=false" />
          </mu-appbar> -->
          <h3>所在地区<span @click="bottomPopup=false"></span></h3>
          <mu-content-block>
            <div class="chooseList forbid-sel-text" v-if="chooseBox" :class="{'chooseTwo':shoWOr==2,'chooseOne':shoWOr==1}">
              <div class="pShow">
                <samp class="sampOne" @click="clickProvince(1)" v-if="shoWOr<=1">请选择</samp>
                <samp @click="clickProvince(2)" v-if="shoWOr>=2">{{addressProvince}}</samp>
                <samp @click="clickProvince(2)" v-if="shoWOr>=3">{{cityNameShow}}</samp>
                <samp class="sampTwo" v-if="shoWOr==2">请选择</samp>
                <!-- <samp @click="clickProvince(2)" v-if="shoWOr<=3">{{cityNameShow}}</samp> -->
                <!-- <samp @click="clickProvince(3)" v-if="shoWOr==3">{{addressProvince}}</samp> -->
              </div>
              <!-- 省 -->
              <div class="chooseProvince" v-if="shoWOr==1">
                <span v-for="provinceShow in arealistMsg" @click="shooseProvince(provinceShow.areaId,provinceShow.areaName)">{{provinceShow.areaName}}</span>
              </div>
              <!-- 市 -->
              <div class="chooseProvince" v-if="shoWOr==2">
                <span v-for="cityShow in cityListShow" @click="shooseCity(cityShow.areaId,cityShow.areaName)" :class="{'chooseCityStyle':chooseCityId==cityShow.areaId}"> {{cityShow.areaName}}</span>
              </div>
              <!-- 区域 -->
              <div class="chooseProvince" v-if="shoWOr==3">
                <span v-for="areaListShow in areaAddressMsg" @click="shooseArea(areaListShow.areaId,areaListShow.areaName)" :class="{'chooseCityStyle':chooseAreaId==areaListShow.areaId}"> {{areaListShow.areaName}}</span>
              </div>
              <!-- 街道/镇 -->
              <div class="chooseProvince" v-if="shoWOr==4">
                <span v-for="streetListShow in getStreetMsgList" @click="shooseStreet(streetListShow.areaId,streetListShow.areaName)" :class="{'chooseCityStyle':chooseStreetId==streetListShow.areaId}"> {{streetListShow.areaName}}</span>
              </div>
              <div class="bottom-btn-box">
                <div class="bottom-full-button">
                  <mu-raised-button label="确认" @click="bottomPopup=false" fullWidth primary/>
                </div>
              </div>
            </div>
          </mu-content-block>
        </mu-popup>
      </div>
      <div class="editButton">
        <mu-raised-button label="保存" fullWidth primary @click="save" />
      </div>
    </div>
    <mu-toast v-if="errorShow==1" message="请核对您输入的信息!" class="custom-toast" />
    <mu-toast v-if="toast2" :message="messageShow" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      addressPopup: false, //位置选择弹框
      addressCode: 0, //获取地址需要传的值
      addressId: this.$route.query.addressId ? this.$route.query.addressId : null, //查询地址详细信息需要的id
      memId: this.$route.query.memId, //会员id
      currentAddress: {
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        area: '',
        townId: '',
        town: '',
        address: '',
        postCode: '',
        consignee: '',
        mobile: '',
        isDefault: 0
      }, //当前地址信息
      addressMsgShow: '', //页面展示的值
      addressProvince: '', //展示省份
      addressCity: '', //展示城市
      chooseCityId: '', //选中城市id
      chooseAreaId: '', //选中的区域id
      chooseStreetId: '', //获取的街道id
      arealistMsg: [], //当前获取到的省份信息
      cityListShow: [], //获取到的城市信息
      areaAddressMsg: [], //获取到城镇信息
      bottomPopup: false, //选择地址弹框
      chooseBox: true, //选择地址弹框
      shoWOr: 1, //初始展示省份一级
      errorShow: 0, //错误信息提示
      toast2: false, //手机号码验证
      messageShow: '', //提示信息
      cityNameShow: '', //城市展示
      areaNameShow: '', //区域名
      getStreetMsgList: '', //最后街道信息
      streetNameShow: '', //街道信息
      lastMsg: '', //最后选中的信息
    }
  },
  watch: {
    topPopup(val) {
      if (val) {
        setTimeout(() => {
          this.topPopup = false
        }, 2000)
      }
    }
  },
  methods: {
    ...mapActions({
      doSetDefaultAddress: 'doSetDefaultAddress', //设置默认地址
      addAddress: 'addAddress', //新增收货地址
      editAddress: 'editAddress', //修改收货地址
      listAreaMsg: 'listAreaMsg', //获取地域列表
      getAddress: 'getAddress', //获取发地址列表
    }),
    //地址出现弹框
    clickProvince(areaId) {
      this.addressMsgShow = '';
      this.addressProvince = '';
      this.cityNameShow = '';
      this.currentAddress.province = '';
      this.currentAddress.provinceId = '';
      this.currentAddress.city = '';
      this.currentAddress.areaId = '';
      this.currentAddress.area = '';
      this.currentAddress.townId = '';
      this.currentAddress.town = '';
      this.shoWOr = 1;
    },
    // 点击省出现下级
    shooseProvince(provinceId, provinceName) {
      this.shoWOr = 2;
      this.getCityListShow(provinceId); //获取城市列表
      this.currentAddress.provinceId = provinceId; //保存id
      this.currentAddress.province = provinceName; //保存名字
      this.addressProvince = provinceName; //名字在页面展示
      this.addressMsgShow = provinceName; //选择框展示
    },
    //点击城市出现下级
    shooseCity(cityId, cityName) {
      this.getTownMsg(cityId); //获取城镇信息
      //setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
      //this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
      this.currentAddress.city = cityName; //保存城市名字
      this.cityNameShow = cityName; //展示城市名字
      this.currentAddress.cityId = cityId; //保存城市id
      this.chooseCityId = cityId; //选中城市的id
      this.addressMsgShow = this.addressProvince + this.cityNameShow;
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
        if (this.areaAddressMsg.length == 0) {
          this.addressMsgShow = this.addressProvince + this.cityNameShow; //选择框展示城市名字
          this.shoWOr = 2; //关闭地址选择框
          return;
        } else if (this.areaAddressMsg.length != 0) {
          this.shoWOr = 3;
        }
      })
    },
    //点击区域出现下一级
    shooseArea(areaId, areaName) {
      this.currentAddress.areaId = areaId; //保存的区域id
      this.chooseAreaId = areaId; //保存的id
      this.currentAddress.area = areaName; //保存地址名称
      this.areaNameShow = areaName; //展示的街道
      this.addressMsgShow = this.addressProvince + this.cityNameShow + this.areaNameShow;
      //this.chooseBox = false; //关闭地址框
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
        if (this.getStreetMsgList.length == 0) {
          this.shoWOr = 3;
        } else {
          this.shoWOr = 4;
        }
      })
    },
    //点击街道出现下一级
    shooseStreet(areaId, areaName) {
      this.currentAddress.townId = areaId; //保存的区域id
      this.chooseStreetId = areaId; //保存街道id
      this.currentAddress.town = areaName; //保存地址名称
      this.streetNameShow = areaName; //展示的街道
      //this.chooseBox = false; //关闭地址框
      this.addressMsgShow = this.addressProvince + this.cityNameShow + this.areaNameShow + this.streetNameShow;
      this.listAreaMsg(areaId).then(res => {
        this.lastMsg = res.target;
      })

    },
    //获取区域的列表api
    getAreaMsg(areaId) {
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
      })
    },
    //获取城镇信息api
    getTownMsg(cityId) {
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
      })
    },
    //获取城市的列表api
    getCityListShow(provinceId) {
      this.listAreaMsg(provinceId).then(result => {
        this.cityListShow = result.target;
      })
    },
    //获取省份列表api
    getListAreaMsg(addressCode) {
      this.listAreaMsg(addressCode).then(result => {
        this.arealistMsg = result.target;

      }).catch(error => {})
    },
    //获取收货地址详细信息api
    getAddressMsg(addressId) {
      this.getAddress(addressId).then(res => {
        this.currentAddress = res;
        this.currentAddress.address = this.currentAddress.address ? this.currentAddress.address : null;
        this.currentAddress.consignee = this.currentAddress.consignee ? this.currentAddress.consignee : null;
        this.currentAddress.mobile = this.currentAddress.mobile ? this.currentAddress.mobile : null;
        this.currentAddress.province = this.currentAddress.province ? this.currentAddress.province : null;
        this.currentAddress.provinceId = this.currentAddress.provinceId ? this.currentAddress.provinceId : null;
        this.currentAddress.city = this.currentAddress.city ? this.currentAddress.city : null;
        this.currentAddress.areaId = this.currentAddress.areaId ? this.currentAddress.areaId : null;
        this.currentAddress.area = this.currentAddress.area ? this.currentAddress.area : null;
        this.currentAddress.townId = this.currentAddress.townId ? this.currentAddress.townId : null;
        this.currentAddress.town = this.currentAddress.town ? this.currentAddress.town : null;
        this.currentAddress.postCode = this.currentAddress.postCode ? this.currentAddress.postCode : null;
        if (this.currentAddress.area == null) {
          this.addressMsgShow = this.currentAddress.city ? this.currentAddress.province + this.currentAddress.city : this.currentAddress.province;
        } else {
          this.addressMsgShow = this.currentAddress.city ? this.currentAddress.province + this.currentAddress.city + this.currentAddress.area : this.currentAddress.province; //当前位置展示的信息
        }
      }).catch(error => {

      })
    },
    isCellPhone(telephone) {
      let reg = /^1\d{10}$/; ///^1[3578]\d{9}$|^(?:0\d{2,3}-?)?[2-9]\d{6,7}$/g;
      let res = reg.test(telephone);
      return res;
    },
    //保存我的地址判断是新增还是修改地址  //验证输入的数字是否正确
    save() {
      var valuechange = this.isCellPhone(this.currentAddress.mobile);
      if (this.currentAddress.consignee == '') {
        this.messageShow = "请输入姓名!";
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false; }, 1500);
      } else if (this.currentAddress.mobile == '' || valuechange == false) {
        this.messageShow = "请验证手机号码!";
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false; }, 1500);
      } else if (this.currentAddress.province == '') {
        this.messageShow = "请选择省份!";
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false; }, 1500);
      } else if (this.currentAddress.city == '') {
        this.messageShow = "请选择城市!";
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false; }, 1500);
      } else if (this.currentAddress.address == '') {
        this.messageShow = "请输入地址!";
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false; }, 1500);
      } else {
        if (this.addressId == null) {
          //alert('新增')
          this.addAddressMsg(this.currentAddress); //新增
        } else {
          //alert('修改')
          this.getEditAddress(this.currentAddress); //修改
        }
      }
    },
    //修改我的地址
    getEditAddress(editMsg) {
      this.editAddress([editMsg]).then(res => {
        this.$router.go(-1);
      }).catch(error => {});
    },
    //新增我的地址
    addAddressMsg(upMsg) {
      this.addAddress(upMsg).then(res => {
        this.$router.go(-1);
      }).catch(error => {})
    },
  },
  mounted() {
    //获取地域列表
    this.getListAreaMsg(this.addressCode);
    //获取当前地址详情
    if (this.addressId != null) {
      this.getAddressMsg(this.addressId);
    } else {
      return
    }
  },
  components: {
    menus
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.physical-popup {
  .popup-content {
    max-height: 6.5rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
}

//地址弹出框的表头
.mu-popup-bottom {
  width: 100%;
  height: 380px;
  font-size: 18px;
  .mu-paper-1 {
    box-shadow: none;
    background-color: #fff;
    span {
      color: #333333;
    }
    div.mu-appbar-title {
      text-align: center;
    }
    .mu-flat-button {
      width: 42px;
      height: 64px;
      background-color: red;
      background: url(/static/images/dialog_cancel.png) no-repeat 0.1rem center; //dialog_cancel.png
    }
  }
}

//地址选择的弹出框内容框
.mu-popup {
  height: 9.5rem;
}

.mu-content-block {
  .chooseList {
    width: 100%;
    height: 9.5rem;
    overflow: auto;
    >.pShow {
      display: inline-block;
      position: fixed;
      background: #fff;
      width: 100%;
      samp {
        // margin-top: 45px;
        @include font-dpr(14px);
        cursor: pointer;
        line-height: 45px;
        margin: 0px 16px;
      }
    }
    .chooseProvince {
      margin-top: 46px;
      margin-bottom: 95px;
      width: 100%;
      @include font-dpr(14px);
      padding-top: 10px;
      border-top: 1px solid #EAEAEA;
      span {
        display: block;
        @include font-dpr(14px);
        cursor: pointer;
        margin: 9px 0px;
        width: 100%;
        text-align: left;
        text-indent: 14px;
        &.chooseCityStyle {
          color: #e60012;
        }
      }
    }
    /*     .boxBtn {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  text-align: center;
  height: 46px;
  line-height: 46px;
  background: linear-gradient(to right, #FF7701, #FF4901);
  @include font-dpr(14px);
  samp {
    @include font-dpr(14px);
  }
} */
    /*底部全屏 button*/
    .bottom-btn-box {
      .bottom-full-button {
        width: 100%;
        position: fixed;
        left: 0px;
        bottom: 0px;
        .mu-raised-button-full {
          @include font-dpr(16px);
          line-height: 1.25rem;
          height: 1.25rem;
          background-image: linear-gradient(-90deg, #FF4901 0%, #FF7701 100%);
        }
      }
    }
    &.chooseOne {
      .pShow>samp.sampOne {
        @include font-dpr(14px);
        color: #E60012;
        display: inline-block;
        border-bottom: 1px solid #E60012;
      }
    }
    &.chooseTwo {
      .pShow>samp.sampTwo {
        @include font-dpr(14px);
        color: #E60012;
        display: inline-block;
        border-bottom: 1px solid #E60012;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// writeaddress.vue?123e4430